import React from "react";
import "./ParentAdminMemberFilters.css";

import { SearchOutlined } from "@ant-design/icons";
import { ChantInput, ChantSelect } from "../../../../CommonComponents";

const ParentAdminMemberFilters = ({
  handleFilterChange,
  filters,
  groupNameOptions,
  hideGroupSelection,
}) => {
  return (
    <div className="pa-members-filters-container">
      <div style={{ width: "15rem" }}>
        <ChantInput
          placeholder="Search Name/Email"
          value={filters.searchTerm}
          prefix={<SearchOutlined />}
          onChange={(e) => {
            handleFilterChange("searchTerm", e.target.value);
          }}
        />
      </div>

      {!hideGroupSelection && (
        <div style={{ width: "15rem" }}>
          <ChantSelect
            value={filters.group}
            placeholder="Select Group"
            options={[
              { value: null, label: "All Groups" },
              ...(groupNameOptions || []),
            ]}
            onChange={(value) => {
              handleFilterChange("group", value);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ParentAdminMemberFilters;
